export {default} from "./TranslatableLabel";
